export const dashboardText = {
    workspaces: "Environnement",
    meterplan: "Plan de comptage",
    plan: "Plan",
    data: "Données",
    displayiot: "Afficher les IoT",
    displayeq: "Afficher les équipements",
    displaydata: "Afficher la donnée",
    alerts: "Alertes",
    alertcritical: "Critique",
    alertimportant: "Important",
    alertwarning: "Avertissement",
    alertinfo: "Information",
    plandatatablenodata: "Aucune donnée à afficher",
    editionmode: "Mode édition",
    newplan: "Ajout d'un plan de comptage",
    editplan: "Edition d'un plan de comptage",
    newplanitem: "Ajout d'un élément",
    editplanitem: "Edition d'un élément",
    dataof: "Données de ",
    menumeteringplanaddplan: "Créer un nouveau plan de comptage",
    menumeteringplandelplan: "Supprimer le plan de comptage",
    menumeteringplaneditplan: "Editer le plan de comptage",
    menumeteringplanadditem: "Ajouter un élément au plan de comptage",
    meteringplandeleted: "Le plan a été supprimé",
    menuaddworkspace: "Créer un nouvel environnement",
    menumdelworkspace: "Supprimer l'environnement",
    menumeditworkspace: "Editer l'environnement",
    workspacedeleted: "L'environnement a été supprimé",
    newworkspace: "Ajout d'un environnement",
    editworkspace: "Edition d'un environnement",
    sankeydialog: "Flux de consommation",
    menu2dplanaddplan: "Créer un nouveau plan",
    menu2dplandelplan: "Supprimer le plan",
    menu2dplaneditplan: "Editer le plan",
    menu2dplanadditem: "Ajouter un élément au plan",
    plan2ddeleted: "Le plan a été supprimé",
    new2dplan: "Ajout d'un plan",
    edit2dplan: "Edition d'un plan",
    delplanitem: "Supprimer l'élément",
    elementdeleted: "L'élément a été supprimé",
    equipmentstatus: "Etat des équipements",
    filters: "Filtres",
    filterallitems: "Tous les équipements",
    fullscreen: "Plein écran",
    moveplanitem: "Déplacer l'élément",
    refresh: "Actualiser la donnée",
    displayonlynames: "Afficher les noms",

}

export const automationText = {
    title: "Automatisations",
    menuaddautomation: "Ajouter une automatisation",
    name: "Nom",
    emptydesc: "Description vide",
    description: "Description",
    selectedequipments: " équipement(s) sélectionné(s)",
    selectedequipmentstitle: "Equipement(s) sélectionné(s)",
    automation: "Automatisation",
    equipmentname: "Nom de l'équipement",
    hardware: "Modèle",
    undefinedhardware: "Non défini",
    controltype: "Type de consigne",
    defaultval: "Valeur par défaut",
    startautomation: "Démarrrer l'automatisation",
    stopautomation: "Arréter l'automatisation",
    editautomation: "Editer l'automatisation",
    delautomation: "Supprimer l'automatisation",
    confirmdelautomation: "Êtes-vous sûr de vouloir supprimer l'automatisation ",
    delautomationconfirmed: "L'automatisation a été supprimée",
    automationstarted: "Automatisation lancée",
    automationstoped: "Automatisation arrétée",
    automationdatebegin: "Date de début",
    automationdateend: "Date de fin",
    automationval: "Valeur",
    confirmstopautomation: "Êtes-vous sûr de vouloir arréter l'automatisation?",
    confirmyes: "Oui",
    confirmno: "Non",
    included: "Inclus",
    includedlength: "Nombre d'équipements inclus",
    unselectall: "Déselectionner tout",
    selectall: "Selectionner tout",
    allmodels: "Tous les modèles",
    automationtype: "Type d'automatisation",
    forcesaver: "Forcer le passage en pilotage actif",
    lastlauch: "Dernier lancement",
    type: "Type",
    lastvalue: "Dernière valeur utilisée",
    changeschedule: "Modifier le planning",
    changeformula: "Modifier la formule de pilotage",
    defaultschedule: "Planning par défaut",
    defaultformula: "Formule par défaut",
    lastschedule: "Dernier planning utilisé",
    lastformula: "Dernière formule utilisée",
    syncciteos: "Synchroniser avec l'hyperviseur",
    filterpoints: "Merci de préciser les consignes concernées (toutes si pas de sélection)",
    actions: "Actions",
    actionscount: "actions(s)",
    editactions: "Modifier les actions",
    lastactions: "Dernières actions",
    triggers: "Déclencheurs",
    triggercount: "déclencheur(s)",
    edittriggers: "Modifier les déclencheurs",
    actionstext: "Actions qui seront effectuées au lancement de l'automatisation",
    triggerstext: "Déclencheurs optionnels de l'automatisation",
    triggertype: "Type de déclencheur",
    triggerdatelimit: "Limiter dans le temps",
    triggerqrcodepin: "Demander un code",
    triggerqrcodepinhelper: "Code à 4 chiffres",
    triggerdownloadqr: "Télécharger le QR Code",
    triggerdatestart: "Date de début",
    triggerdateend: "Date de fin",
    triggerchooseduration: "Permettre de choisir la durée",
    triggerchoosedurationmin: "Durée minimum (mn)",
    triggerchoosedurationmax: "Durée maximum (max)",
    triggerselectedbadgers: " badgeuse(s) sélectionnée(s)",
    triggerauthorizedbadges: "Badges autorisés",
    triggerduration: "Durée par défaut",
    triggercanstop: "Permettre d'interrompre une automatisation en cours",
}

export const meteringPlanText = {
    name: "Nom",
    description: "Description",
    group: "Périmètre",
    isdefault: "Plan par défaut de l'environnement",
}

export const plan2dText = {
    name: "Nom",
    category: "Catégorie",
    description: "Description",
    group: "Périmètre",
    image: "Image de fond",
    isdefault: "Plan par défaut de l'environnement",
    defaultview: "Vue par défaut",
    displayiot: "Afficher la vue 'IoT'",
    displayeq: "Afficher la vue 'Equipements'",
    displaydata: "Afficher la vue 'Data'",
}

export const workspaceText = {
    name: "Nom",
    description: "Description",
    group: "Périmètre",
    isdefault: "Environnement par défaut du groupe",
    chart1: "Graphique 1",
    chart2: "Graphique 2",
    displayAutomationWidget: "Afficher le widget d'automatisation",
    order2dplans: "Trier les plans 2D",
}

export const metringPlanItemText = {
    name: "Nom",
    valuetype: "Type de valeur",
    value: "Valeur",
    controltype: "Type de contrôle",
    controlvalue: "Valeur de contrôle",
    unit: "Unité",
    coef: "Coéficient appliqué",
    usage: "Usage",
    location: "Localisation",
    locationtype: "Type de localisation",
    tags: "Tags",
    father: "Elément parent",
    icon: "Icone",
}

export const plan2dItemText = {
    name: "Nom",
    displayname: "Afficher le nom sur le plan",
    type: "Type",
    value: "Valeur",
    iot: "Objet communicant",
    equipment: "Equipement",
    box: "Box",
    valuetype: "Type de valeur",
    valueagg: "Affichage de la donnée sur la plan",
    controltype: "Type de contrôle",
    controlvalue: "Valeur de contrôle",
    unit: "Unité",
    coef: "Coéficient appliqué",
    usage: "Usage",
    location: "Localisation",
    locationtype: "Type de localisation",
    tags: "Tags",
    father: "Elément parent",
    icon: "Icone",
    iconsize: "Taille de l'icone",
    nodata: "Aucune valeur trouvée",
    datatime: "Date de la valeur",
    textsize: "Taille du texte",
    defaultvalcolor: "Couleur par défaut",
    lowvalcolor: "Couleur du seuil bas",
    highvalcolor: "Couleur du seuil haut",
    lowvalstep: "Seuil bas",
    highvalstep: "Seuil haut",
    connexiontime: "Date de la dernière connexion",
    noconnexiontime: "Aucune valeur de dernière connexion",
    linkedplan: "Plan lié",
    linkto: "Lien vers le plan",
    nolinkto: "Lien erroné",
    linkpower: "Puissance radio",
    battery: "Batterie",
    deveui: "DEV EUI",
    eosprotocol: "Source",
    associatediot: "Objet IoT associé",
    category: "Catégorie",
    primaryvalue: "Valeur caractéristique",
    associatedequipment: "Equipement associé",
    associatedvariables: "Variables associées",
    associatedequipments: "Equipements associés",
    showadvanced: "Voir les paramètres avancés",
    equipmentpoints: "Affichage des points dans le dialogue",
}

export const scriptText = {
    name: "Nom",
    description: "Description",
    destination: "Destination",
    triggers: "Déclencheurs",
    scriptpython: "Script",
    author: "Auteur",
    modifier: "Modifié par",
    lastupdate: "Dernière modification",
    lastrun: "Dernier lancement",
    duration: "Durée",
    writenvalues: "Valeurs écrites",
    console: "Retour console",
}

